import React from "react";
import { Routes, Route } from "react-router-dom";
import MarcarAsistencia from "../screens/MarcarAsistencia";
import RegistrosAsistencia from "../screens/RegistrosAsistencia";
import RegistrosSSHH from "../screens/RegistrosSSHH";
import RegistrosTareas from "../screens/RegistrosTareas";
import ListaTareas from "../screens/ListaTareas";
import NuevaTarea from "../forms/NuevaTarea";
import EditarTarea from "../forms/EditarTarea";
import RRHH from "../screens/RRHH";
import Contabilidad from "../screens/Contabilidad";
import Inicio from "../screens/Inicio";
import Search from "../screens/Search";
import Trabajadores from "../screens/Trabajadores";
import Tutoriales from "../screens/Tutoriales";
import EditarPerfil from "../forms/EditarPerfil";
import Seguimiento from "../screens/Seguimiento";
import SeguimientoDetails from "../screens/SeguimientoDetails";
import CotizacionPDF from "../screens/Cotizaciones/CotizacionPDF";
import Cotizaciones from "../screens/Cotizaciones/Cotizaciones";
import EncuestasRespuestasDetails from "../screens/EncuestasRespuestasDetails";
import AfiliacionClientes from "../screens/AfiliacionClientes";
import RedesClientes from "../screens/RedesClientes";
import CalendarioCobranzas from "../screens/CalendarioCobranzas";
import CalendarioCitas from "../screens/CalendarioCitas";
import Incidencias from "../screens/Incidencias";
import NuevaIncidencia from "../components/Incidencias/NuevaIncidencia"
import EditarIncidencia from "../components/Incidencias/EditarIncidencia"
import RegistrosAsistenciaAdmin from "../screens/RegistrosAsistenciaAdmin";
import RegistroCompras from "../screens/RegistroCompras";
import RegistroVentas from "../screens/RegistroVentas";
import EstadisticasTrabajador from "../screens/EstadisticasTrabajador";
import Estadisticas from "../screens/Estadisticas";
import PagosTrabajadores from "../screens/PagosTrabajadores";
import PagosRecurrentes from "../screens/PagosRecurrentes";
import NuevoPago from "../components/pagosTrabajadores/NuevoPago";
import SeguimientoClienteDetails from "../screens/SeguimientoClienteDetails";
import SeguimientoServiciosCliente from "../screens/SeguimientoServiciosCliente";
import NuevoTrabajador from "../screens/NuevoTrabajador";
import EditarTrabajador from "../screens/EditarTrabajador";
import Formularios from "../screens/Formularios";
import FormularioDetails from "../screens/FormularioDetails";
import Horarios from "../screens/Horarios";
import PreciosPromociones from "../screens/PreciosPromociones";
import EditarPago from "../components/pagosTrabajadores/EditarPago";
import Inventario from "../screens/Inventario";
import ReporteDiario from "../screens/ReporteDiario";
import TareasAdministracion from "../screens/TareasAdministracion";
import RedesClientesWebs from "../screens/RedesClientesWebs";
import RegistroLlamadas from "../screens/RegistroLlamadas";
import ReporteDiarioTrabajador from "../screens/ReporteDiarioTrabajador";
import ProyectosWebs from "../screens/ProyectosWebs";
import ProyectosAds from "../screens/ProyectosAds";
import ProyectosSmm from "../screens/ProyectosSmm";
import ProyectosAudiovisuales from "../screens/ProyectosAudiovisuales";
import ProyectosHyD from "../screens/ProyectosHyD";
import CalendarioCumpleanios from "../screens/CalendarioCumpleanios";
import RevisionesServicios from "../screens/RevisionesServicios";
import EncuestasPlantillas from "../screens/EncuestasPlantillas";
import ProyectosSoporteWeb from "../screens/ProyectosSoporteWeb";
import TrackeoLeads from "../screens/TrackeoLeads";
import EventosLeads from "../screens/EventosLead";
import ClientesUser from "../screens/ClientesUser";
import RedesClientesAds from "../screens/RedesClientesAds";
import VentasProyectos from "../screens/VentasProyectos";
import OperativaProyectos from "../screens/OperativaProyectos";
import AudiovisualesProyectos from "../screens/AudiovisualesProyectos";
import { CalendarioCotizaciones } from "../screens/CalendarioCotizaciones";
import ProyectosSoftware from "../screens/ProyectosSoftware";
import DashboardLeads from "../screens/DashboardLeads";
import DasboardLeadsDia from "../screens/DasboardLeadsDia";
import DashboardActividadesComercial from "../screens/DashboardActividadesComercial";
import FunnelLeads from "../screens/FunnelLeads";
import CalendarioEventosLeads from "../screens/CalendarioEventosLeads";
import GastosAgencia from "../screens/GastosAgencia";
import DashboardActividadesComercialHora from "../screens/DashboardActividadesComercialHora";
import RenovacionHostingyDominios from "../screens/RenovacionHostingyDominios";
import IngresosMensuales from "../screens/IngresosMensuales";
import EstadisticaIngresos from "../screens/EstadisticaIngresos";
import RegistroComisiones from "../screens/RegistroComisiones"; 
import ProyectosSEO from "../screens/ProyectosSEO";
import ProyectosUIUX from "../screens/ProyectosUIUX";
import HistorialCancelaciones from "../screens/HistorialCancelaciones";
import HistorialDeudores from "../screens/HistorialDeudores";
import ProyeccionIngresos from "../screens/ProyeccionIngresos"; 
import VentasSupuestos from "../screens/VentasSupuestos";
import RegistroLlamadasManuales from "../screens/RegistroLlamadasManuales";
import Stakeholders from "../screens/Stakeholders";
import Conciliacion from "../screens/Conciliacion";
import ComprasStakeholders from "../screens/ComprasStakeholders";
import IntegracionProyectos from "../screens/IntegracionProyectos";
import SolicitudesPostVenta from "../screens/SolicitudesPostVenta";
import ProyectosSaas from "../screens/ProyectosSaas";
import ProyectosBranding from "../screens/ProyectosBranding";
import ProyectosOtros from "../screens/ProyectosOtros";
import ReglasComisiones from "../screens/ReglasComisiones";
import AsignacionesBloque from "../screens/AsignacionesBloque";
import SalidaProyectos from "../screens/SalidaProyectos";
import Tickets from "../screens/Tickets";
import Correo from "../screens/Correo";
import AdminCorreo from "../screens/AdminCorreo";

const HomeRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Inicio />} />
      <Route path="/search" element={<Search />} />

      {/* Agencia */}
      <Route path="/horarios" element={<Horarios />} />
      <Route path="/rrhh" element={<RRHH />} />
      <Route path="/tutoriales" element={<Tutoriales />} />
      <Route path="/inventario" element={<Inventario />} />
      <Route path="/asignaciones-bloque" element={<AsignacionesBloque />} />
      <Route path="/registroLlamadas" element={<RegistroLlamadas />} />
      <Route path="/ingresos-mensuales" element={<IngresosMensuales />} />
      <Route path="/estadistica-ingresos" element={<EstadisticaIngresos />} />
      <Route path="/registro-comisiones" element={<RegistroComisiones />} />
      <Route path="/reglas-comisiones" element={<ReglasComisiones />} />
      <Route path="/supuestos-ventas" element={<VentasSupuestos />} />
      <Route path="/registroLlamadasManuales" element={<RegistroLlamadasManuales />} />
      <Route path="/proveedores" element={<Stakeholders />} />
      <Route path="/conciliacion" element={<Conciliacion />} />
      
      {/* Proyectos que requieren audiovisual */}
      <Route path="/integracion-proyectos" element={<IntegracionProyectos />} />
      <Route path="/ventas-proyectos" element={<VentasProyectos />} />
      <Route path="/operativa-proyectos" element={<OperativaProyectos />} />
      <Route path="/audiovisual-proyectos" element={<AudiovisualesProyectos />} />

      {/* Asistencia */}
      <Route path="/marcar-asistencia" element={<MarcarAsistencia />} />
      <Route path="/registros-asistencia" element={<RegistrosAsistencia />} />
      <Route path="/registros-sshh" element={<RegistrosSSHH />} />

      {/* Tareas */}
      <Route path="/tareas" element={<ListaTareas />} />
      <Route path="/tareas/nueva-tarea" element={<NuevaTarea />} />
      <Route path="/tareas/lista-tareas/editar-tarea/:id" element={<EditarTarea />}/>
      <Route path="/tareas/registros-tareas/:id" element={<RegistrosTareas />}/>
      <Route path="/bloques-trabajo" element={<TareasAdministracion />} />

      {/* Incidencias */}
      <Route path="/incidencias" element={<Incidencias />} />
      <Route path="/incidencias/nueva-incidencia" element={<NuevaIncidencia />} />
      <Route path="/incidencias/editar-incidencia/:id" element={<EditarIncidencia />} />

      {/* Pagos trabajadores */}
      <Route path="/pagos-trabajadores" element={<PagosTrabajadores />} />
      <Route path="/pagos-trabajadores/nuevo-pago" element={<NuevoPago />} />
      <Route path="/pagos-trabajadores/editar-pago/:registerId" element={<EditarPago />} />
      <Route path="/pagos-recurrentes" element={<PagosRecurrentes />} />

      <Route path="/trabajadores" element={<Trabajadores />} />
      <Route path="/trabajadores/nuevo-trabajador" element={<NuevoTrabajador />} />
      <Route path="/trabajadores/editar-trabajador/:id" element={<EditarTrabajador />} />

      {/* Proyectos */}
      <Route path="/salidaProyectos" element={<SalidaProyectos />} />
      <Route path="/proyectosWebs" element={<ProyectosWebs />} />
      <Route path="/proyectosSoftware" element={<ProyectosSoftware />} /> 
      <Route path="/proyectosSEO" element={<ProyectosSEO />} />
      <Route path="/proyectosUIUX" element={<ProyectosUIUX />} />
      <Route path="/proyectosAds" element={<ProyectosAds />} />
      <Route path="/proyectosSmm" element={<ProyectosSmm />} />
      <Route path="/proyectosAudiovisuales" element={<ProyectosAudiovisuales />} />
      <Route path="/proyectosHostingDominios" element={<ProyectosHyD />} />
      <Route path="/proyectosSoporteWeb" element={<ProyectosSoporteWeb />} />
      <Route path="/proyectosBranding" element={<ProyectosBranding />} />
      <Route path="/proyectosOtros" element={<ProyectosOtros />} />
      <Route path="/proyectosSaas" element={<ProyectosSaas />} />

      {/* Seguimiento */}
      <Route path="/seguimiento" element={<Seguimiento />} />
      <Route path="/seguimiento/:id" element={<SeguimientoClienteDetails />} />
      <Route path="/seguimiento/:id/:activeServices" element={< SeguimientoServiciosCliente />} />
      <Route path="/seguimiento/encuestas-respuestas/:id" element={<EncuestasRespuestasDetails />}/>
      <Route path="/seguimiento/:id/:activeServices/:serviceId" element={<SeguimientoDetails />} />

      {/* Cotizaciones */}
      <Route path="/cotizaciones" element={<Cotizaciones />} />
      <Route path="/calendario-cotizaciones" element={<CalendarioCotizaciones />} />
      <Route path="/cotizaciones/:id" element={<CotizacionPDF />} />
      <Route path="/solicitudes-post-venta" element={<SolicitudesPostVenta />} />

      {/* Trabajador */}
      <Route path="/estadisticas-trabajador" element={<EstadisticasTrabajador />} />
      <Route path="/estadisticas" element={<Estadisticas />} />
      <Route path="/editar-perfil" element={<EditarPerfil />} />
      <Route path="/reporteDiario" element={<ReporteDiario />} />
      <Route path="/misReportesDiarios" element={<ReporteDiarioTrabajador />} />

      {/* Calendiarios */}
      <Route path="/calendario-cobranza" element={<CalendarioCobranzas />} />
      <Route path="/calendario-citas" element={<CalendarioCitas />} />
      <Route path="/calendarioRevisiones" element={<RevisionesServicios />} />

      {/* Clientes */}
      <Route path="/tickets" element={<Tickets />} />
      <Route path="/clientesUsuarios" element={<ClientesUser />} />
      <Route path="/trackeoLeads" element={<TrackeoLeads />} />
      <Route path="/funnelLeads" element={<FunnelLeads />} />
      <Route path="/calendarioEventosLeads" element={<CalendarioEventosLeads />} />
      <Route path="/dashboardLeads" element={<DashboardLeads />} />
      <Route path="/dashboardLeadsDia" element={<DasboardLeadsDia />} />
      <Route path="/dashboardActividadesComercial" element={<DashboardActividadesComercial />} />
      <Route path="/dashboardActividadesComercialHora" element={<DashboardActividadesComercialHora />} />
      <Route path="/trackeoLeads/:leadId" element={<EventosLeads />} />
      <Route path="/cumpleanios" element={<CalendarioCumpleanios />} />
      <Route path="/precios-y-promociones" element={<PreciosPromociones />} />
      <Route path="/historial-cancelaciones" element={<HistorialCancelaciones />} />
      <Route path="/historial-deudores" element={<HistorialDeudores />} />

      {/* Fomrularios */}
      <Route path="/formularios" element={<Formularios />} />
      <Route path="/formularios/:id" element={<FormularioDetails />} />

      {/* Encuestas */}
      <Route path="/plantillasEncuestas" element={<EncuestasPlantillas />} />
      
      {/* Otras secciones */}      
      <Route path="/contabilidad" element={<Contabilidad />} />
      <Route path="/proyeccion-ingresos" element={<ProyeccionIngresos/>} />
      <Route path="/gastos-agencia" element={<GastosAgencia />} />
      <Route path="/registro-asistencias-admin" element={<RegistrosAsistenciaAdmin />} />
      <Route path="/registro-compras" element={<RegistroCompras />} />
      <Route path="/registro-ventas" element={<RegistroVentas />} />
      <Route path="/compras-proveedores" element={<ComprasStakeholders />} />
      {/* <Route path="/registro-de-ventas" element={<RegistroVentasIndependientes />} /> */}
      <Route path="/afiliacion-clientes" element={<AfiliacionClientes />} />
      <Route path="/renovacionHostingydominios" element={<RenovacionHostingyDominios />} />

      {/* Redes clientes */}
      <Route path="/redes-clientes" element={<RedesClientes />} />
      <Route path="/redes-clientes-webs" element={<RedesClientesWebs />} />
      <Route path="/redes-clientes-ads" element={<RedesClientesAds />} />

      {/* Correo */}
      <Route path="/correo" element={<Correo />} />
      <Route path="/admin-correo" element={<AdminCorreo />} />
    </Routes>
  );
};

export default HomeRoutes;
